var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9523 5.70227C18.3332 7.18727 18.3332 10.2873 18.3332 10.2873C18.3332 10.2873 18.3332 13.3873 17.9523 14.8723C17.7407 15.6931 17.1215 16.3389 16.3373 16.5573C14.9132 16.9539 9.99984 16.9539 9.99984 16.9539C9.99984 16.9539 5.089 16.9539 3.66234 16.5573C2.87484 16.3356 2.2565 15.6906 2.04734 14.8723C1.6665 13.3873 1.6665 10.2873 1.6665 10.2873C1.6665 10.2873 1.6665 7.18727 2.04734 5.70227C2.259 4.88144 2.87817 4.23561 3.66234 4.01727C5.089 3.62061 9.99984 3.62061 9.99984 3.62061C9.99984 3.62061 14.9132 3.62061 16.3373 4.01727C17.1248 4.23894 17.7432 4.88394 17.9523 5.70227ZM8.33317 13.2039L13.3332 10.2873L8.33317 7.3706V13.2039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d8f9e9dd1e35468f6298d459eb562134.svg";
export { ForwardRef as ReactComponent };